import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do landscapers get more leads in Colorado?",
    "a": "Local SEO plus a tuned Google Business Profile plus service-specific pages — lawn care, sod, irrigation, hardscaping, design-build. Companies that rank for each service capture buyers at every intent."
  },
  {
    "q": "Is SEO worth it for seasonal landscaping?",
    "a": "Yes — seasonality is exactly why SEO matters. You need leads scheduled before the season starts. Ranking by February means a full schedule by April."
  },
  {
    "q": "Should landscapers run Google Ads?",
    "a": "Yes for spring start-up, irrigation, and design-build. PPC is profitable for high-ticket services where one job covers months of spend. For mow-and-blow, SEO wins."
  },
  {
    "q": "What's the highest-ROI service to market?",
    "a": "Design-build and hardscaping — $15k–$100k projects. We build dedicated pages, galleries, and lead forms for each high-ticket service."
  },
  {
    "q": "Do you market snow removal too?",
    "a": "Yes — we build snow contract landing pages that convert in Q4 so your winter is booked before the first storm."
  }
];

export const Route = createFileRoute("/landscaping-marketing-colorado")({
  head: () =>
    industryMarketingHead("Landscaping", "landscaping company", "landscaping-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Landscaping"}
      industryLower={"landscaping company"}
      slug={"landscaping-marketing-colorado"}
      subheadline={"We help Colorado landscaping and lawn-care companies stay booked through every season — from spring cleanups to fall aeration and snow contracts."}
      painPoints={["Schedule fills only in spring, then dies through summer and fall","Your site looks the same as every other landscaper in town","You rely on door hangers and referrals — there's no inbound pipeline"]}
      serviceDescriptions={{
        seo: "Rank for landscaping, lawn care, sod, irrigation, hardscaping, and every service — every Colorado market.",
        googleMaps: "Dominate 'landscaper near me' in the Map Pack across every neighborhood you service.",
        webDesign: "Portfolio-driven sites with before/after galleries that win bids and pre-qualify buyers.",
        ppc: "Seasonal Google Ads tuned to spring cleanup, irrigation start-up, and fall aeration peaks.",
        geoAi: "Get cited when buyers ask ChatGPT 'best landscaper in Colorado Springs' or 'landscape design near me'.",
        socialMedia: "Instagram-first content with project reels that turn into qualified leads.",
      }}
      testimonial={{"quote":"Our schedule is full from March through November and we finally have a winter pipeline. The site closes for us before the consult.","role":"Landscaping Company Owner","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/landscaping-marketing-colorado-springs","label":"Landscaping marketing in Colorado Springs","description":"Drought-smart landscape design and lawn care across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Landscaping marketing in Denver","description":"Compete in Denver's saturated landscape and design-build market."},{"to":"/landscaping-marketing-castle-rock","label":"Landscaping marketing in Castle Rock","description":"High-end residential landscape design across Castle Rock and Douglas County."},{"to":"/landscaping-marketing-parker","label":"Landscaping marketing in Parker","description":"Landscape design, sod, and irrigation leads across Stonegate and The Pinery."}]}
    />
  ),
});
